export { default as SortAscIcon } from './SortAscIcon';
